import { render, staticRenderFns } from "./root.vue?vue&type=template&id=059c7a46&scoped=true&"
import script from "./root.vue?vue&type=script&lang=js&"
export * from "./root.vue?vue&type=script&lang=js&"
import style0 from "./root.vue?vue&type=style&index=0&id=059c7a46&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059c7a46",
  null
  
)

export default component.exports